import React, { Component } from 'react'
import NewReplyCommentForm from './newreplycommentform'
import NewCommentForm from './newcommentform'
import NewCommentReply from './newcommentreply'
import moment from 'moment'
import { compose } from 'redux'
import { Icon, message } from 'antd'
// import './icon.scss';

class NewComment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showReplyForm: false,
      subcomments: [],
      likedComment: false
    }
  }

  componentDidMount() {
    this.setState({
      subcomments: this.props.commentDetail.subcomments
    })
  }

  componentWillReceiveProps(nextProps) {
    const { commentDetail, profile } = nextProps
    if (commentDetail.subcomments.length > 0) {
      const sortedSubComments = commentDetail.subcomments.sort((a, b) => new Date(a.created) - new Date(b.created))
      this.setState({
        subcomments: sortedSubComments
      })
    }
    if (profile.uid) {
      if (commentDetail.likers.includes(profile.uid)) {
        this.setState({
          likedComment: true
        })
      } else {
        this.setState({
          likedComment: false
        })
      }
    }

  }

  toggleReplyCommentForm = (e) => {
    e.preventDefault()
    const { showReplyForm } = this.state
    this.setState({
      showReplyForm: !showReplyForm
    })
  }

  closeReplyForm = () => {
    this.setState({
      showReplyForm: false
    })
  }

  onLikeComment = (e) => {
    e.preventDefault()
    const { commentDetail, profile, postId } = this.props
    if (!profile.uid) {
      message.error('You need to be logged in!');
    } else {
      var likers = commentDetail.likers
      likers.push(profile.uid)
      var commentDetails = {
        postId,
        commentId: commentDetail.id,
        likers
      }
      this.props.likeComment(commentDetails)
    }
  }

  onDislikeComment = (e) => {
    e.preventDefault()
    const { commentDetail, profile, postId } = this.props
    if (!profile.uid) {
      message.error('You need to be logged in!');
    } else {
      var likers = commentDetail.likers
      var index = likers.indexOf(profile.uid)
      if (index > -1) {
        likers.splice(index, 1);
      }
      var commentDetails = {
        postId,
        commentId: commentDetail.id,
        likers
      }
      this.props.unLikeComment(commentDetails)
    }
  }

  render() {
    const { showReplyForm, subcomments, likedComment } = this.state
    const { commentDetail } = this.props
    // console.log(subcomments.length, subcomments)
    return (
      <div className="single-commnet clearfix">
        <img src="/img/user.png" alt="" className="float-left" />
        <div className="comment float-left border">
          <div className="clearfix">
            <h6 className="float-left">{commentDetail.commenterName}</h6>
            <span className="float-right">{moment(commentDetail.created).fromNow()}</span>
          </div>
          <p>{commentDetail.content}</p>
          <ul>
            <li className="likeornot">
              {
                likedComment ? <a href="#" onClick={(e) => this.onDislikeComment(e)}>
                  <Icon type="dislike" theme="filled" />
                  {commentDetail.likes}
                </a> : <a href="#" onClick={(e) => this.onLikeComment(e)}>
                    <Icon type="like" theme="filled" />
                    {commentDetail.likes}
                  </a>
              }
            </li>
            <li><a href="#" onClick={(e) => this.toggleReplyCommentForm(e)}><i className="fa fa-share" aria-hidden="true"></i> Reply</a></li>
            {/* <li>
              <a href="#">
              <Icon type="delete" theme="filled" />
              Delete
              </a>
            </li> */}
          </ul>
          {
            showReplyForm ? <NewReplyCommentForm sendReplyComment={this.props.sendReplyComment} commentId={commentDetail.id} profile={this.props.profile} postId={this.props.postId} closeReplyForm={this.closeReplyForm} /> : ''
          }
          <div className="subs">
            {
              subcomments.length > 0 && subcomments.map((subcomment) => (
                <NewCommentReply key={subcomment.id} subcomment={subcomment} likeSubComment={this.props.likeSubComment} unLikeSubComment={this.props.unLikeSubComment} commentId={commentDetail.id} profile={this.props.profile} postId={this.props.postId} />
              ))
            }
          </div>

        </div>
      </div>
    )
  }
}

export default NewComment